//region :: Imports ::
import {ReactElement} from 'react';
import {Navigate} from 'react-router-dom';
import MComponent from '../Component';
import MAuthProvider from './AuthProvider';
import {hasRoles, isNullOrUndefined} from '../../Utils';

//endregion

/** */
type Props = {
    roles: string[];
    accessDeniedRoute?: string;
    children: ReactElement;
};

/** */
class MAuthorize extends MComponent<Props> {

    /** */
    public render(): ReactElement | ReactElement[] {

        const accessDeniedRoute = isNullOrUndefined(this.props.accessDeniedRoute) ? '/access-denied' : this.props.accessDeniedRoute!;
        return !hasRoles(this.props.roles, MAuthProvider.msalContext) ? <Navigate replace to={accessDeniedRoute}/> : this.props.children;

    }

}

export default MAuthorize;
